/**
 * SkeletonCard — shared loading placeholder used in Focus Area and Requirements grids.
 * Consistent pulse animation across both sub-steps.
 */
const SkeletonCard = ({ lines = 3, height }) => (
  <div
    className="dark:bg-white/10 bg-gray-200 rounded-lg p-4 animate-pulse backdrop-blur-sm border border-white/10 flex flex-col justify-center"
    style={height ? { height } : { minHeight: "120px" }}
  >
    <div className="h-4 dark:bg-gray-600 bg-gray-300 rounded mb-3 w-3/4" />
    {lines >= 2 && <div className="h-3 dark:bg-gray-600 bg-gray-300 rounded w-4/5" />}
    {lines >= 3 && <div className="h-2 dark:bg-gray-600 bg-gray-300 rounded w-3/5 mt-2" />}
  </div>
);

export default SkeletonCard;
